<ion-header>
  <ion-toolbar>
    <ion-buttons slot="end">
      <ion-button (click)="goBack()" [color]="'danger'"> Cancelar </ion-button>
    </ion-buttons>
    <ion-title> Provincias </ion-title>
  </ion-toolbar>

  <ion-toolbar>
    <ion-searchbar
      inputmode="search"
      [enterkeyhint]="'search'"
      [placeholder]="'Escribe la provincia'"
      (keyup.enter)="search()"
      (ionChange)="search_item()"
      [formControl]="searchControl"
      #searchbar
    ></ion-searchbar>
  </ion-toolbar>
  <!--  -->
</ion-header>
<ion-content>
  <ion-list>
    <ion-item style="width: 100%" *ngFor="let province of provinceList" (click)="choose(province)">
      <span (keyup.enter)="choose(province)">
        {{ province.nombre }}
      </span>
    </ion-item>
  </ion-list>
</ion-content>
